import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'itemTenantFilter'
})
export class FilterTenantItemPipe implements PipeTransform {

  transform(value: any, termItem: string, attrValue: string, attrTenant: string): any {
    let checkTerm: any;
    return termItem ?
      value.filter(objectList => {
        if (!objectList.tenants || (objectList.tenants && objectList.tenants.includes(attrTenant))) {
          let someArray = attrValue.split('.');
          for (let entry of someArray) {
            objectList = objectList[entry];
          }
          checkTerm = termItem;
          if (termItem.toString() === 'true') {
            checkTerm = true;
          }
          if (termItem.toString() === 'false') {
            checkTerm = false;
          }
          return objectList === checkTerm;
        }
      })
      : value;
  }

 /* transform(value: any, attrValue: string): any {

  // value: [... {id: 'data_archiviazione', label: 'Data archiviazione', idGruppo: 'pratica', tenants: ['PRD']},...]
  // termItemArray ['PRD']
  // attrValue FS

    return attrValue ?
    value.filter(objectList => {
      if (objectList.tenants && objectList.tenants.includes(attrTenant)) {
        return objectList;
      }
    })
    : value;
  }*/
}
